import React from "react";
import { CheckCircle2 } from "lucide-react";
import Reveal from "../Reveal";

const items = [
  "Atendimento humanizado",
  "Profissionais especializados",
  "Estrutura moderna",
  "Ambiente seguro",
  "Equipamentos de qualidade",
  "Muito carinho com cada pet",
  "Atendimento individualizado",
  "Segurança e conforto",
];

export default function Differentials() {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative overflow-hidden py-28 sm:py-36 text-white bg-transparent"
    >
      <div className="container-pad relative z-10">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal
              as="div"
              className="inline-block px-5 py-2 rounded-full bg-white/10 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em] mb-6"
            >
              Diferenciais
            </Reveal>

            <Reveal
              as="h2"
              delay={80}
              className="font-heading text-4xl lg:text-6xl text-white leading-tight"
            >
              Muito mais que um
              <span className="italic text-gold block">
                banho e tosa.
              </span>
            </Reveal>

            <Reveal
              as="p"
              delay={150}
              className="mt-8 text-lg leading-8 text-white/75"
            >
              Nosso compromisso é proporcionar uma experiência tranquila,
              segura e acolhedora para cada pet. Cada detalhe foi pensado
              para que ele volte para casa feliz.
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid md:grid-cols-2 gap-6">
              {items.map((item, index) => (
                <Reveal
                  key={item}
                  delay={100 + index * 70}
                  className="group relative overflow-hidden rounded-[32px] border border-white/15 bg-white/10 backdrop-blur-2xl p-7 hover:-translate-y-2 hover:scale-[1.02] transition-all duration-500 shadow-[0_25px_80px_rgba(0,0,0,.25)]"
                >
                  <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-gold/15 blur-3xl opacity-0 group-hover:opacity-100 transition duration-700"></div>

                  <div className="flex items-center gap-5 relative">
                    <div className="w-14 h-14 rounded-2xl bg-gold flex items-center justify-center shadow-[0_20px_40px_rgba(242,169,0,.35)] group-hover:rotate-[-8deg] group-hover:scale-110 transition-all">
                      <CheckCircle2
                        className="w-7 h-7 text-royal"
                        strokeWidth={2.4}
                      />
                    </div>

                    <h3 className="font-heading text-xl text-white font-semibold leading-tight">
                      {item}
                    </h3>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
